/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eslint-comments/no-duplicate-disable */
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, resetReduxStore } from '../../store'
import {
  selectMenuItemById,
  setSelectedItemIds,
  setSelectedItems,
} from '../SideNavigation/SideNavigationSlice'

//Icon imports:
import UserIcon from '../../assets/icons/UserIcon'
import chevron from '../../assets/chevron.svg'
import WeatherSensorDetailsIcon from '../../assets/icons/WeatherSensorDetailsIcon'
import LogoutIcon from '../../assets/icons/LogoutIcon'
import ThresholdsIcon from '../../assets/icons/ThresholdsIcon'
import FaqIcon from '../../assets/icons/FaqIcon'
import SavedViewIcon from '../../assets/icons/SavedViewIcon'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import AlertIcon from '../../assets/icons/AlertIcon'
import FeatureGate from '../../Components/FeatureGate/FeatureGate'
import { MENU_ID } from '../../environment/featureFlags'

import {
  createSavedView,
  deleteSavedView,
} from '../../Components/SavedViews/savedViews'
import { setSavedProfile } from '../../Components/SavedViews/savedViewsSlice'
import RestoreSelection from '../../Components/SavedViews/RestoreSelection'
import useErrorStatus from '../../hooks/UseErrorStatus'
import {
  baseMapItems,
  exclusiveItems,
  toggledItems,
} from '../SideNavigation/SideNavigation'
import { ErrorTimeouts } from '../../constants/ErrorTimeouts'
import { useAuth0 } from '@auth0/auth0-react'
import {useClickAway} from 'react-use';

export default function ProfileMenu() {
  const [show, setShow] = useState(false)
  const [authenticated, setAuthenticated] = useState(false)
  const [isSubDropdownOpen, setisSubDropdownOpen] = useState(true)
  const [isAddingNew, setIsAddingNew] = useState(false)
  const [newProfileName, setNewProfileName] = useState('')
  const selectedItems = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )
  const selectedItemIds = useSelector(
    (state: RootState) => state.sideNav.selectedItems
  )
  const firstname = useSelector(
    (state: RootState) => state.user.firstname || state.user.name
  )
  const lastname = useSelector((state: RootState) => state.user.lastname)
  const savedProfiles = useSelector(
    (state: RootState) => state.savedProfile.savedProfiles
  )
  const signInRef = useRef(null)
  const signUpRef = useRef(null)
  const itemSelected = () => {
    setShow(false)
  }
  const dispatch = useDispatch()
  const { isAuthenticated, logout } = useAuth0()

  const isDarkMode = useSelector((state) => state.mapState.darkMode)

  const [confirmViewDelete, setConfirmViewDelete] = useState(false)

  const toggleSubDropdown = () => {
    setisSubDropdownOpen(!isSubDropdownOpen)
  }
  const confirmDelete = async (profileId) => {
    let tempSavedProfiles = [...savedProfiles]
    tempSavedProfiles = tempSavedProfiles.filter(
      (element) => element.id !== profileId
    )
    dispatch(setSavedProfile(tempSavedProfiles))
    await deleteSavedView(profileId)
  }

  const handleDelete = async (profileId) => {
    if (confirm('Are you sure you want to delete this profile?')) {
      confirmDelete(profileId)
    }
  }

  const { activateSelectedProducts } = RestoreSelection()
  const errorStatus = useErrorStatus()

  const hasCommonElement = (array1: string[], array2: string[]): boolean => {
    const set2 = new Set(array2)
    return array1.some((item) => set2.has(item))
  }

  const handleSaveNewProfile = async () => {
    if (!newProfileName) {
      errorStatus.addMessage(
        'Name is required for a new profile.',
        200,
        'error',
        false,
        ErrorTimeouts.USER_PROFILE
      )
      return
    }
    const savableItems = [
      ...exclusiveItems,
      ...toggledItems,
      ...baseMapItems,
      'decision-missioncast',
    ]
    if (!hasCommonElement(selectedItemIds, savableItems)) {
      errorStatus.addMessage(
        'Please select at least one product to save a new profile.',
        200,
        'error',
        false,
        ErrorTimeouts.USER_PROFILE
      )
      return
    }
    const createdSavedView = await createSavedView(newProfileName, [
      selectedItems,
      selectedItemIds,
    ])
    const tempSavedProfiles = [...savedProfiles]
    tempSavedProfiles.push(createdSavedView)
    dispatch(setSavedProfile(tempSavedProfiles))
    setNewProfileName('')
    setIsAddingNew(false)
  }

  const handleActivateSavedView = async (profiles) => {
    profiles[1].forEach((item) => {
      dispatch(selectMenuItemById(item))
    })
    dispatch(setSelectedItems(profiles))
    activateSelectedProducts(profiles[1])
  }

  const handleCancelNewProfile = () => {
    setIsAddingNew(false)
    setNewProfileName('')
  }

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })

  const handleMenuToggle = () => {
    setShow(!show)
  }

  const ref = useRef(null);
  useClickAway(ref, () => {
    setShow(false)
  });
  return (
    <div ref={ref}>
      <div
        className={`flex flex-row justify-start items-center text-center items-center p-4 w-auto cursor-pointer text-white hover:bg-twsBlueSecondary rounded-lg`}
        onClick={handleMenuToggle}
      >
        <div>
          <UserIcon darkMode={true} />
        </div>
        <span className="capitalize">{firstname}</span>
        <img
          className="invert px-2"
          src={chevron}
          alt=""
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </div>
      <div
        className={`absolute block transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in overflow-hidden ${
          isDarkMode ? 'bg-navigationBg text-white' : 'bg-white text-black'
        }
            ${
              show
                ? 'max-h-1/4 opacity-100 scale-100 z-[99999]'
                : 'max-h-0 opacity-0 scale-95'
            }
          } top-16 right-1 w-72  shadow-lg rounded-b-lg p-4 space-y-4`}
           
      >
        <div className="capitalize font-semibold space-y-2">
          {firstname} {lastname}
        </div>

        <hr className="border-gray-700" />

        <div className="space-y-2">
          <div className="flex flex-row items-center gap-2 cursor-pointer">
            <SavedViewIcon darkMode={isDarkMode} />
            <p>Saved Views</p>
            <button
              onClick={() => setIsAddingNew(true)}
              className="bg-green-700 py-1 px-3 rounded text-white"
            >
              Add New
            </button>
          </div>

          {isSubDropdownOpen && (
            <div className="space-y-2">
              <div className="px-2">
                {/* {savedProfiles.length < 3 && isAddingNew && (
                <div className="space-y-2">
                  <input
                    type="text"
                    value={newProfileName}
                    onChange={(e) => setNewProfileName(e.target.value)}
                    placeholder="Enter profile name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    required
                  />
                  <div className="text-center flex gap-2">
                    <button
                      onClick={handleSaveNewProfile}
                      className="bg-green-700 py-1 px-3 rounded text-white"
                    >
                      Save
                    </button>
                    <button
                      onClick={handleCancelNewProfile}
                      className="bg-red-700 py-1 px-3 rounded text-white"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )} */}
                <div
                  className={`transition-all duration-500 overflow-hidden space-y-2 ${
                    isAddingNew && savedProfiles.length < 3
                      ? 'max-h-96 opacity-100 scale-100'
                      : 'max-h-0 opacity-0 scale-95'
                  }`}
                >
                  <input
                    type="text"
                    value={newProfileName}
                    onChange={(e) => setNewProfileName(e.target.value)}
                    placeholder="Enter profile name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                    required
                  />
                  <div className="text-center flex gap-2">
                    <button
                      onClick={handleSaveNewProfile}
                      className="bg-green-700 py-1 px-3 rounded text-white"
                    >
                      Save
                    </button>
                    <button
                      onClick={handleCancelNewProfile}
                      className="bg-red-700 py-1 px-3 rounded text-white"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>

              {savedProfiles.length > 0 && (
                <div className="space-y-2">
                  {savedProfiles.map((element, index) => (
                    <div
                      key={index}
                      className={`py-2 px-4 flex justify-between items-center rounded cursor-pointer ${
                        isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
                      } group`}
                      onClick={() => {
                        dispatch(setSelectedItems([]))
                        dispatch(setSelectedItems(element.profiles[0]))
                        dispatch(setSelectedItemIds([]))
                        dispatch(setSelectedItemIds(element.profiles[1]))
                        setShow(false)
                      }}
                    >
                      <span
                        onClick={() =>
                          handleActivateSavedView(element.profiles)
                        }
                        className={`truncate ${
                          isDarkMode
                            ? 'bg-black text-white group-hover:bg-gray-800'
                            : 'bg-white text-black group-hover:bg-gray-100'
                        } `}
                      >
                        {element.profileName}
                      </span>
                      <button
                        className="ml-2 bg-red-700 p-1 rounded"
                        onClick={(e) => {
                          e.stopPropagation()
                          handleDelete(element.id)
                        }}
                      >
                        <DeleteIcon darkMode={true} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        <hr className="border-gray-700" />

        <div className="space-y-2">
          <Link to="/userprofile" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <UserIcon darkMode={isDarkMode} />
              <p>Your Profile</p>
            </div>
          </Link>
          <Link to="/sensordetails" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <WeatherSensorDetailsIcon darkMode={isDarkMode} />
              <p>Weather Sensor Details</p>
            </div>
          </Link>
          <Link to="/customthresholds" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <ThresholdsIcon darkMode={isDarkMode} />
              <p>Units & Thresholds</p>
            </div>
          </Link>
          {/*
            Monitors and Alerts is gated on both axes - the build-time flag and
            the user's region. Alerting is listed in every region's product set,
            so `requireRegion` is not restricting today; it is passed so this
            entry answers the same question the side nav does, and so removing
            alerting from a region later takes effect here too.
          */}
          <FeatureGate flag={MENU_ID.ALERTING_MONITORS} requireRegion>
            <Link to="/alerts" onClick={itemSelected}>
              <div
                className={`flex items-center gap-2 h-8 cursor-pointer ${
                  isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
                }`}
              >
                <AlertIcon darkMode={isDarkMode} />
                <p>Monitors and Alerts</p>
              </div>
            </Link>
          </FeatureGate>
          <Link to="https://truweathersolutions.gitbook.io/info/documentation" target="_blank" onClick={itemSelected}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <FaqIcon darkMode={isDarkMode} />
              <p>Help</p>
            </div>
          </Link>
        </div>

        <hr className="border-gray-700" />

        <div className="space-y-2">
          <Link to="." onClick={logoutWithRedirect}>
            <div
              className={`flex items-center gap-2 h-8 cursor-pointer ${
                isDarkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
              }`}
            >
              <LogoutIcon darkMode={isDarkMode} />
              <p>Logout</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
